import ActivateAccount from './ActivateAccount';

export default ActivateAccount;